import React from 'react';

export type RoutingContextType = {
    navRoute: boolean,
    canOpenScreenSizeAlert?: boolean,
    setCanOpenScreenSizeAlert?: React.Dispatch<React.SetStateAction<boolean>>
  };

export const defaultContextValue: RoutingContextType = {
  navRoute: false,
};
